import { Form } from "react-bootstrap";
import Select from "react-select";

const SelectInput = ({
  monthFilter,
  switchBtn,
  title,
  handleSetFilterState,
  handleSetSwitch,
  filterCol,
  options,
}) => {
  return (
    <div>
      <div className="d-flex justify-content-between mb-4">
        <div>{title}</div>
        <div>
          {" "}
          <Form.Check
            type="switch"
            id="custom-switch"
            checked={switchBtn}
            onChange={(e) => handleSetSwitch(e.target.checked, filterCol)}
          />
        </div>
      </div>
      {switchBtn && (
        <Form >
          {options?.map((option, index) => (
            <Form.Check
              inline
              checked={monthFilter===option.value}
              onChange={(e) => handleSetFilterState(option.value, filterCol)}
              label={option.label}
              type={"radio"}
              id={`inline-${option.label}-1`}
            />
          ))}
        </Form>
      )}
    </div>
  );
};
export default SelectInput;
